import { useEffect, useState } from 'react';
import { useCookies } from 'react-cookie';

export const useVisitOffset = (max = 11) => {
  const [cookies, setCookie] = useCookies(['visitCount']);
  const [visitOffset] = useState(() => {
    const raw = cookies.visitCount ?? '0';
    const prev = parseInt(raw, 10) || 0;
    return (prev + 1) % max;
  });

  useEffect(() => {
    setCookie('visitCount', String(visitOffset), {
      path: '/',
      maxAge: 60 * 60 * 24 * 365,
    });
  }, []);

  return visitOffset;
};
